import React, { Component } from "react";
import { Segment, Table, Input, Grid, Button, Icon } from "semantic-ui-react";

import sortBy from "lodash/sortBy";
import find from "lodash/find";
import groupBy from "lodash/groupBy";
import isEmpty from "lodash/isEmpty";
import orderBy from "lodash/orderBy";
import titleCase from "title-case";
import moment from "moment";

const _ = {
  sortBy,
  find,
  groupBy,
  isEmpty,
  orderBy,
};

const changeCase = {
  titleCase: titleCase,
};

class SectionStudents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      searchKey: "",
      fields: ["name", "1st", "2nd", "3rd", "4th"],
      selectedIndex: 0,
      column: null,
      direction: null,
      studentName: "",
      id: "",
      sectionId: "",
      filtered: false,
      currentQuarter: 1,
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.handlePaginationChangeMale =
      this.handlePaginationChangeMale.bind(this);
    this.handlePaginationChangeFemale =
      this.handlePaginationChangeFemale.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  filterTopTen = () => {
    this.setState({ filtered: !this.state.filtered });
  };

  isSearched(searchKey) {
    return function (item) {
      return (
        !searchKey ||
        item.student.firstName
          .toLowerCase()
          .includes(searchKey.toLowerCase()) ||
        item.student.lastName.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  onSearchChange(event) {
    this.setState({ searchKey: event.target.value });
  }

  handleSort(clickedColumn) {
    const { column, data, direction } = this.state;
    if (column !== clickedColumn) {
      if (clickedColumn === "name") {
        this.setState({
          column: clickedColumn,
          data: _.sortBy(data, function (o) {
            return o.student.lastName;
          }),
          direction: "ascending",
        });
        return;
      } else {
        this.setState({
          column: clickedColumn,
          data: _.sortBy(data, [clickedColumn]),
          direction: "ascending",
        });
        return;
      }
    }
    this.setState({
      data: data.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending",
    });
  }

  handlePaginationChangeMale(e, { activePage }) {
    this.setState({
      activePageMale: activePage,
    });
  }

  handlePaginationChangeFemale(e, { activePage }) {
    this.setState({
      activePageFemale: activePage,
    });
  }

  componentDidMount() {
    let currentQuarter;
    let currentMonth = moment().month() + 1;
    if (currentMonth > 8 && currentMonth < 11) {
      currentQuarter = 1;
    } else if (
      (currentMonth > 11 && currentMonth < 13) ||
      (currentMonth > 0 && currentMonth < 2)
    ) {
      currentQuarter = 2;
    } else if (currentMonth > 1 && currentMonth < 3) {
      currentQuarter = 3;
    } else if (currentMonth > 2 && currentMonth < 7) {
      currentQuarter = 4;
    }
    this.setState({ data: this.props.sectionStudents, currentQuarter });
  }

  componentWillReceiveProps(newProps) {
    this.setState({ data: newProps.sectionStudents });
  }

  render() {
    const {
      column,
      direction,
      data,
      searchKey,
      fields,
      filtered,
      currentQuarter,
    } = this.state;
    if (_.isEmpty(data)) return null;

    const gender = _.groupBy(data, (o) => o.student.gender);
    let currentDataMale = [],
      currentDataFemale = [];
    if (gender.hasOwnProperty("Male")) {
      currentDataMale = gender["Male"].filter(this.isSearched(searchKey));
    }

    if (gender.hasOwnProperty("Female")) {
      currentDataFemale = gender["Female"].filter(this.isSearched(searchKey));
    }
    let studentAverage = [];

    const studentsTableMale = currentDataMale.map((sectionStudent, key) => {
      const studentName =
        sectionStudent.student.lastName +
        ", " +
        sectionStudent.student.firstName;
      let firstTotal = 0,
        secondTotal = 0,
        thirdTotal = 0,
        fourthTotal = 0;
      let firstAverage = 0,
        secondAverage = 0,
        thirdAverage = 0,
        fourthAverage = 0;
      for (let i = 0; i < sectionStudent.grades.length; i++) {
        firstTotal = firstTotal + sectionStudent.grades[i].firstQuarter;
        secondTotal = secondTotal + sectionStudent.grades[i].secondQuarter;
        thirdTotal = thirdTotal + sectionStudent.grades[i].thirdQuarter;
        fourthTotal = fourthTotal + sectionStudent.grades[i].fourthQuarter;
      }
      firstAverage = Math.round(firstTotal / sectionStudent.grades.length);
      secondAverage = Math.round(secondTotal / sectionStudent.grades.length);
      thirdAverage = Math.round(thirdTotal / sectionStudent.grades.length);
      fourthAverage = Math.round(fourthTotal / sectionStudent.grades.length);

      // Add 10% conduct
      if (sectionStudent.classConducts.length !== 0) {
        firstAverage = parseFloat(
          firstAverage * 0.9 +
            sectionStudent.classConducts[0].firstQuarterFinal * 0.1
        ).toFixed(2);
        secondAverage = parseFloat(
          secondAverage * 0.9 +
            sectionStudent.classConducts[0].secondQuarterFinal * 0.1
        ).toFixed(2);
        thirdAverage = parseFloat(
          thirdAverage * 0.9 +
            sectionStudent.classConducts[0].thirdQuarterFinal * 0.1
        ).toFixed(2);
        fourthAverage = parseFloat(
          fourthAverage * 0.9 +
            sectionStudent.classConducts[0].fourthQuarterFinal * 0.1
        ).toFixed(2);
      }
      studentAverage.push({
        firstName: sectionStudent.student.firstName,
        lastName: sectionStudent.student.lastName,
        sectionId: sectionStudent.sectionId,
        sectionStudentId: sectionStudent.sectionStudentId,
        firstAverage: parseFloat(firstAverage),
        secondAverage: parseFloat(secondAverage),
        thirdAverage: parseFloat(thirdAverage),
        fourthAverage: parseFloat(fourthAverage),
      });
      return (
        <Table.Row
          key={key}
          className="sections-table-row"
          onClick={() =>
            this.props.handleRowClick(
              sectionStudent.sectionId,
              sectionStudent.sectionStudentId
            )
          }
        >
          <Table.Cell>{studentName}</Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {firstAverage}
          </Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {secondAverage}
          </Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {thirdAverage}
          </Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {fourthAverage}
          </Table.Cell>
        </Table.Row>
      );
    });

    const studentsTableFemale = currentDataFemale.map((sectionStudent, key) => {
      const studentName =
        sectionStudent.student.lastName +
        ", " +
        sectionStudent.student.firstName;
      let firstTotal = 0,
        secondTotal = 0,
        thirdTotal = 0,
        fourthTotal = 0;
      let firstAverage = 0,
        secondAverage = 0,
        thirdAverage = 0,
        fourthAverage = 0;
      for (let i = 0; i < sectionStudent.grades.length; i++) {
        firstTotal = firstTotal + sectionStudent.grades[i].firstQuarter;
        secondTotal = secondTotal + sectionStudent.grades[i].secondQuarter;
        thirdTotal = thirdTotal + sectionStudent.grades[i].thirdQuarter;
        fourthTotal = fourthTotal + sectionStudent.grades[i].fourthQuarter;
      }
      firstAverage = Math.round(firstTotal / sectionStudent.grades.length);
      secondAverage = Math.round(secondTotal / sectionStudent.grades.length);
      thirdAverage = Math.round(thirdTotal / sectionStudent.grades.length);
      fourthAverage = Math.round(fourthTotal / sectionStudent.grades.length);

      if (sectionStudent.classConducts.length === 0) {
        firstAverage = 0;
        secondAverage = 0;
        thirdAverage = 0;
        fourthAverage = 0;
      } else {
        firstAverage = parseFloat(
          firstAverage * 0.9 +
            sectionStudent.classConducts[0].firstQuarterFinal * 0.1
        ).toFixed(2);
        secondAverage = parseFloat(
          secondAverage * 0.9 +
            sectionStudent.classConducts[0].secondQuarterFinal * 0.1
        ).toFixed(2);
        thirdAverage = parseFloat(
          thirdAverage * 0.9 +
            sectionStudent.classConducts[0].thirdQuarterFinal * 0.1
        ).toFixed(2);
        fourthAverage = parseFloat(
          fourthAverage * 0.9 +
            sectionStudent.classConducts[0].fourthQuarterFinal * 0.1
        ).toFixed(2);
      }
      studentAverage.push({
        firstName: sectionStudent.student.firstName,
        lastName: sectionStudent.student.lastName,
        sectionId: sectionStudent.sectionId,
        sectionStudentId: sectionStudent.sectionStudentId,
        firstAverage: parseFloat(firstAverage),
        secondAverage: parseFloat(secondAverage),
        thirdAverage: parseFloat(thirdAverage),
        fourthAverage: parseFloat(fourthAverage),
      });
      return (
        <Table.Row
          key={key}
          className="sections-table-row"
          onClick={() =>
            this.props.handleRowClick(
              sectionStudent.sectionId,
              sectionStudent.sectionStudentId
            )
          }
        >
          <Table.Cell>{studentName}</Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {firstAverage}
          </Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {secondAverage}
          </Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {thirdAverage}
          </Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {fourthAverage}
          </Table.Cell>
        </Table.Row>
      );
    });
    if (currentQuarter === 1) {
      studentAverage = _.orderBy(studentAverage, ["firstAverage"], ["desc"]);
    } else if (currentQuarter === 2) {
      studentAverage = _.orderBy(studentAverage, ["secondAverage"], ["desc"]);
    } else if (currentQuarter === 3) {
      studentAverage = _.orderBy(studentAverage, ["thirdAverage"], ["desc"]);
    } else if (currentQuarter === 4) {
      studentAverage = _.orderBy(studentAverage, ["fourthAverage"], ["desc"]);
    } else {
      console.log("create filter for final average");
    }
    studentAverage = studentAverage.splice(0, 10);
    const topTenTable = studentAverage.map((student, key) => {
      const studentName = student.lastName + ", " + student.firstName;
      return (
        <Table.Row
          key={key}
          className="sections-table-row"
          onClick={() =>
            this.props.handleRowClick(
              student.sectionId,
              student.sectionStudentId
            )
          }
        >
          <Table.Cell>{studentName}</Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {student.firstAverage}
          </Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {student.secondAverage}
          </Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {student.thirdAverage}
          </Table.Cell>
          <Table.Cell collapsing textAlign="right">
            {student.fourthAverage}
          </Table.Cell>
        </Table.Row>
      );
    });

    const headers = fields.map((field, index) => {
      return (
        <Table.HeaderCell
          key={index}
          sorted={column === field ? direction : null}
          onClick={() => this.handleSort(field)}
          textAlign="center"
        >
          {changeCase.titleCase(field)}
        </Table.HeaderCell>
      );
    });

    return (
      <div className="table-sections">
        <Grid>
          <Grid.Column floated="left" width={14}>
            <Input
              icon="search"
              fluid
              value={searchKey}
              onChange={this.onSearchChange}
              className="section-students-search"
              placeholder="Search Students"
            />
          </Grid.Column>
          <Grid.Column floated="right" width={2}>
            <Button
              icon
              floated="right"
              color="yellow"
              onClick={() => this.filterTopTen()}
            >
              <Icon name="star" />
            </Button>
          </Grid.Column>
        </Grid>
        {data.length > 0 ? (
          <Grid centered>
            {filtered ? (
              <Grid.Column width={8}>
                <Table celled selectable sortable striped compact size="small">
                  <Table.Header>
                    <Table.Row>{headers}</Table.Row>
                  </Table.Header>

                  <Table.Body>{topTenTable}</Table.Body>
                </Table>
              </Grid.Column>
            ) : (
              <React.Fragment>
                <Grid.Column width={8}>
                  <h4>Male</h4>
                  <Table
                    celled
                    selectable
                    sortable
                    striped
                    compact
                    size="small"
                  >
                    <Table.Header>
                      <Table.Row>{headers}</Table.Row>
                    </Table.Header>

                    <Table.Body>{studentsTableMale}</Table.Body>
                  </Table>
                </Grid.Column>
                <Grid.Column width={8}>
                  <h4>Female</h4>
                  <Table
                    celled
                    selectable
                    sortable
                    striped
                    compact
                    size="small"
                  >
                    <Table.Header>
                      <Table.Row>{headers}</Table.Row>
                    </Table.Header>

                    <Table.Body>{studentsTableFemale}</Table.Body>
                  </Table>
                </Grid.Column>
              </React.Fragment>
            )}
          </Grid>
        ) : (
          <Segment>No student records found.</Segment>
        )}
      </div>
    );
  }
}

export default SectionStudents;
